<div class="grid">
  <div class="col-12 md:ml-5 py-4">
    <div class="flex-auto flex-wrap justify-content-center">
      <form [formGroup]="consentForm">
        <div class="col-12 ml-2 mb-2">
          <span class="label">{{ 'Consent_Info.Print_The_Consents' | translate }}</span>
        </div>
        <div class="col-12 flex">
          <div class="md:col-5">
            <p-select id="dropdown"
              [options]="languageOptions"
              optionValue="value"
              formControlName="languageId"
              optionLabel="label"
              aria-describedby="Language"
              class="w-full" />
          </div>
          <div class="md:col-7">
            <p-button label="{{ 'Consent_Info.Download_Consent' | translate }}"
              styleClass="p-button-rounded"
              (onClick)="onDownloadConsent()"
              [loading]="downloadInProgress" />
          </div>
        </div>
        <div class="col-12 flex">
          <div class="md:col-5">
            <span class="label">{{ 'Consent_Info.Consent_Part1' | translate }}</span>
            <br />
            <span class="label">{{ 'Consent_Info.Consent_Part2' | translate }}</span>
          </div>
          <div class="md:col-7 flex align-items-center">
            @for (option of consentOptions; track option) {

              <p-radioButton inputId="{{ 'consent.' + option.value }}"
                [value]="option.value"
                name="consent"
                formControlName="consent" />
              <label for="{{ 'consent.' + option.value }}" class="mr-2 justify-content-center">{{
                option.label
              }}</label>
            
}
          </div>
        </div>
        <div class="col-12 flex">
          <div class="md:col-5">
            <span class="label">{{ 'Consent_Info.SampleConsent_Part1' | translate }}</span>
            <br />
            <span class="label">{{ 'Consent_Info.SampleConsent_Part2' | translate }}</span>
          </div>
          <div class="md:col-7 flex align-items-center">
            @for (option of consentOptions; track option) {

              <p-radioButton inputId="{{ 'sampleConsent.' + option.value }}"
                [value]="option.value"
                name="sampleConsent"
                formControlName="sampleConsent" />
              <label for="{{ 'sampleConsent.' + option.value }}" class="mr-2 justify-content-center">{{
                option.label
              }}</label>
            
}
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
